const countryTranslations = {
  ad: "एंडोरा",
  ae: "संयुक्त अरब अमीरात",
  af: "अफ़गानिस्तान",
  ag: "एंटिगुआ और बरबुडा",
  ai: "एंग्विला",
  al: "अल्बानिया",
  am: "आर्मेनिया",
  ao: "अंगोला",
  ar: "अर्जेंटीना",
  as: "अमेरिकी समोआ",
  at: "ऑस्ट्रिया",
  au: "ऑस्ट्रेलिया",
  aw: "अरूबा",
  ax: "एलैंड द्वीपसमूह",
  az: "अज़रबैजान",
  ba: "बोस्निया और हर्ज़ेगोविना",
  bb: "बारबाडोस",
  bd: "बांग्लादेश",
  be: "बेल्जियम",
  bf: "बुर्किना फ़ासो",
  bg: "बुल्गारिया",
  bh: "बहरीन",
  bi: "बुरुंडी",
  bj: "बेनिन",
  bl: "सेंट बार्थेलेमी",
  bm: "बरमूडा",
  bn: "ब्रूनेई",
  bo: "बोलीविया",
  bq: "कैरिबियन नीदरलैंड",
  br: "ब्राज़ील",
  bs: "बहामास",
  bt: "भूटान",
  bw: "बोत्स्वाना",
  by: "बेलारूस",
  bz: "बेलीज़",
  ca: "कनाडा",
  cc: "कोकोस (कीलिंग) द्वीपसमूह",
  cd: "कांगो - किंशासा",
  cf: "मध्य अफ़्रीकी गणराज्य",
  cg: "कांगो – ब्राज़ाविल",
  ch: "स्विट्ज़रलैंड",
  ci: "कोट डी आइवर",
  ck: "कुक द्वीपसमूह",
  cl: "चिली",
  cm: "कैमरून",
  cn: "चीन",
  co: "कोलंबिया",
  cr: "कोस्टारिका",
  cu: "क्यूबा",
  cv: "केप वर्ड",
  cw: "क्यूरासाओ",
  cx: "क्रिसमस द्वीप",
  cy: "साइप्रस",
  cz: "चेकिया",
  de: "जर्मनी",
  dj: "जिबूती",
  dk: "डेनमार्क",
  dm: "डोमिनिका",
  do: "डोमिनिकन गणराज्य",
  dz: "अल्जीरिया",
  ec: "इक्वाडोर",
  ee: "एस्टोनिया",
  eg: "मिस्र",
  eh: "पश्चिमी सहारा",
  er: "इरिट्रिया",
  es: "स्पेन",
  et: "इथियोपिया",
  fi: "फ़िनलैंड",
  fj: "फ़िजी",
  fk: "फ़ॉकलैंड द्वीपसमूह",
  fm: "माइक्रोनेशिया",
  fo: "फ़ेरो द्वीपसमूह",
  fr: "फ़्रांस",
  ga: "गैबॉन",
  gb: "यूनाइटेड किंगडम",
  gd: "ग्रेनाडा",
  ge: "जॉर्जिया",
  gf: "फ़्रेंच गुयाना",
  gg: "गर्नसी",
  gh: "घाना",
  gi: "जिब्राल्टर",
  gl: "ग्रीनलैंड",
  gm: "गाम्बिया",
  gn: "गिनी",
  gp: "ग्वाडेलूप",
  gq: "इक्वेटोरियल गिनी",
  gr: "यूनान",
  gt: "ग्वाटेमाला",
  gu: "गुआम",
  gw: "गिनी-बिसाउ",
  gy: "गुयाना",
  hk: "हाँग काँग (चीन विशेष प्रशासनिक क्षेत्र)",
  hn: "होंडूरास",
  hr: "क्रोएशिया",
  ht: "हैती",
  hu: "हंगरी",
  id: "इंडोनेशिया",
  ie: "आयरलैंड",
  il: "इज़राइल",
  im: "आइल ऑफ़ मैन",
  in: "भारत",
  io: "ब्रिटिश हिंद महासागरीय क्षेत्र",
  iq: "इराक",
  ir: "ईरान",
  is: "आइसलैंड",
  it: "इटली",
  je: "जर्सी",
  jm: "जमैका",
  jo: "जॉर्डन",
  jp: "जापान",
  ke: "केन्या",
  kg: "किर्गिज़स्तान",
  kh: "कंबोडिया",
  ki: "किरिबाती",
  km: "कोमोरोस",
  kn: "सेंट किट्स और नेविस",
  kp: "उत्तर कोरिया",
  kr: "दक्षिण कोरिया",
  kw: "कुवैत",
  ky: "कैमेन द्वीपसमूह",
  kz: "कज़ाखस्तान",
  la: "लाओस",
  lb: "लेबनान",
  lc: "सेंट लूसिया",
  li: "लिचेंस्टीन",
  lk: "श्रीलंका",
  lr: "लाइबेरिया",
  ls: "लेसोथो",
  lt: "लिथुआनिया",
  lu: "लग्ज़मबर्ग",
  lv: "लातविया",
  ly: "लीबिया",
  ma: "मोरक्को",
  mc: "मोनाको",
  md: "मॉल्डोवा",
  me: "मोंटेनेग्रो",
  mf: "सेंट मार्टिन",
  mg: "मेडागास्कर",
  mh: "मार्शल द्वीपसमूह",
  mk: "उत्तरी मकदूनिया",
  ml: "माली",
  mm: "म्यांमार (बर्मा)",
  mn: "मंगोलिया",
  mo: "मकाऊ (विशेष प्रशासनिक क्षेत्र चीन)",
  mp: "उत्तरी मारियाना द्वीपसमूह",
  mq: "मार्टीनिक",
  mr: "मॉरिटानिया",
  ms: "मोंटसेरात",
  mt: "माल्टा",
  mu: "मॉरीशस",
  mv: "मालदीव",
  mw: "मलावी",
  mx: "मैक्सिको",
  my: "मलेशिया",
  mz: "मोज़ांबिक",
  na: "नामीबिया",
  nc: "न्यू कैलेडोनिया",
  ne: "नाइजर",
  nf: "नॉरफ़ॉक द्वीप",
  ng: "नाइजीरिया",
  ni: "निकारागुआ",
  nl: "नीदरलैंड",
  no: "नॉर्वे",
  np: "नेपाल",
  nr: "नाउरु",
  nu: "नीयू",
  nz: "न्यूज़ीलैंड",
  om: "ओमान",
  pa: "पनामा",
  pe: "पेरू",
  pf: "फ़्रेंच पोलिनेशिया",
  pg: "पापुआ न्यू गिनी",
  ph: "फ़िलिपींस",
  pk: "पाकिस्तान",
  pl: "पोलैंड",
  pm: "सेंट पिएरे और मिक्वेलान",
  pr: "पोर्टो रिको",
  ps: "फ़िलिस्तीनी क्षेत्र",
  pt: "पुर्तगाल",
  pw: "पलाऊ",
  py: "पराग्वे",
  qa: "क़तर",
  re: "रियूनियन",
  ro: "रोमानिया",
  rs: "सर्बिया",
  ru: "रूस",
  rw: "रवांडा",
  sa: "सऊदी अरब",
  sb: "सोलोमन द्वीपसमूह",
  sc: "सेशेल्स",
  sd: "सूडान",
  se: "स्वीडन",
  sg: "सिंगापुर",
  sh: "सेंट हेलेना",
  si: "स्लोवेनिया",
  sj: "स्वालबार्ड और जान मायेन",
  sk: "स्लोवाकिया",
  sl: "सिएरा लियोन",
  sm: "सैन मेरीनो",
  sn: "सेनेगल",
  so: "सोमालिया",
  sr: "सूरीनाम",
  ss: "दक्षिण सूडान",
  st: "साओ टोम और प्रिंसिपे",
  sv: "अल सल्वाडोर",
  sx: "सिंट मार्टिन",
  sy: "सीरिया",
  sz: "स्वाज़ीलैंड",
  tc: "तुर्क और कैकोज़ द्वीपसमूह",
  td: "चाड",
  tg: "टोगो",
  th: "थाईलैंड",
  tj: "ताज़िकिस्तान",
  tk: "तोकेलाउ",
  tl: "तिमोर-लेस्त",
  tm: "तुर्कमेनिस्तान",
  tn: "ट्यूनीशिया",
  to: "टोंगा",
  tr: "तुर्की",
  tt: "त्रिनिदाद और टोबैगो",
  tv: "तुवालू",
  tw: "ताइवान",
  tz: "तंज़ानिया",
  ua: "यूक्रेन",
  ug: "युगांडा",
  us: "संयुक्त राज्य",
  uy: "उरूग्वे",
  uz: "उज़्बेकिस्तान",
  va: "वेटिकन सिटी",
  vc: "सेंट विंसेंट और ग्रेनाडाइंस",
  ve: "वेनेज़ुएला",
  vg: "ब्रिटिश वर्जिन द्वीपसमूह",
  vi: "यू॰एस॰ वर्जिन द्वीपसमूह",
  vn: "वियतनाम",
  vu: "वनुआतू",
  wf: "वालिस और फ़्यूचूना",
  ws: "समोआ",
  ye: "यमन",
  yt: "मायोते",
  za: "दक्षिण अफ़्रीका",
  zm: "ज़ाम्बिया",
  zw: "ज़िम्बाब्वे"
};
export default countryTranslations;